import dayjs from 'dayjs';

// @ts-ignore tsgo is having trouble picking up the module types in the alpha
import bankHolidays from '@motorway/motorway-sale-rules/lib/data/bankHolidays';

interface BankHolidayEvent {
  date: string;
  title: string;
}

const englandWalesHolidays: BankHolidayEvent[] = bankHolidays['england-and-wales']?.events ?? [];

export const isOfficeHours = () => {
  const today = dayjs() || {};
  const dayOfWeek = today?.day();
  const todaysDate = today?.format('YYYY-MM-DD');
  const hours = today?.hour();
  const holiday = englandWalesHolidays.some((bankHoliday) => bankHoliday.date === todaysDate);

  if (holiday || dayOfWeek === 0 || dayOfWeek === 6) {
    return hours >= 9 && (hours < 17);
  }

  return hours >= 9 && hours < 19;
};

interface OpeningHoursProps {
  closingTime: string;
  currentTime?: number;
  openingTime: string;
}

export const areAgentsAvailable = (
  { closingTime, currentTime = Date.now(), openingTime }: OpeningHoursProps,
): boolean => {
  const offsetMs = new Date().getTimezoneOffset() * 60000;

  const opening = new Date(openingTime).getTime() + offsetMs;
  const closing = new Date(closingTime).getTime() + offsetMs;

  return currentTime >= opening && currentTime < closing;
};
